import { render, staticRenderFns } from "./FooterLogos.vue?vue&type=template&id=369da92d&scoped=true"
import script from "./FooterLogos.vue?vue&type=script&lang=js"
export * from "./FooterLogos.vue?vue&type=script&lang=js"
import style0 from "./FooterLogos.vue?vue&type=style&index=0&id=369da92d&prod&lang=scss"
import style1 from "./FooterLogos.vue?vue&type=style&index=1&id=369da92d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369da92d",
  null
  
)

export default component.exports